import { render, staticRenderFns } from "./iDS404NotFound.vue?vue&type=template&id=ff0af30e"
import script from "./iDS404NotFound.vue?vue&type=script&lang=js"
export * from "./iDS404NotFound.vue?vue&type=script&lang=js"
import style0 from "./iDS404NotFound.vue?vue&type=style&index=0&id=ff0af30e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports